import { useEffect, useState } from 'react';

interface UseFeedFocusOptions<T> {
    entityId: string;
    enabled?: boolean;
    getId: (item: T) => string;
    setInteraction: (
        focusedId: string | null,
        onSelect: ((item: T) => void) | null,
    ) => void;
}

export function useFeedFocus<T>({
    entityId,
    enabled = true,
    getId,
    setInteraction,
}: UseFeedFocusOptions<T>) {
    const [focusedItem, setFocusedItem] = useState<T | null>(null);
    const focusedId = focusedItem ? getId(focusedItem) : null;

    useEffect(() => {
        setFocusedItem(null);
    }, [entityId]);

    useEffect(() => {
        const id = enabled ? focusedId : null;
        const handler = enabled ? setFocusedItem : null;
        setInteraction(id, handler);
    }, [enabled, focusedId, setInteraction]);

    useEffect(() => () => setInteraction(null, null), [setInteraction]);

    return { focusedItem, setFocusedItem };
}
